import { render, staticRenderFns } from "./TeacherBankAccountFormView.vue?vue&type=template&id=2b6ced5b&scoped=true&"
import script from "./TeacherBankAccountFormView.vue?vue&type=script&lang=js&"
export * from "./TeacherBankAccountFormView.vue?vue&type=script&lang=js&"
import style0 from "./TeacherBankAccountFormView.vue?vue&type=style&index=0&id=2b6ced5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ced5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VForm,VRow,VSubheader})
